import { Button } from "antd";
import { get } from "lodash";
import { BiMenu, BiTrash } from "react-icons/bi";

const TYPE_CONFIG = {
  email: { icon: "📧", label: "Email", color: "#1a9bdb" },
  linkedinInvite: { icon: "🔗", label: "LinkedIn Invite", color: "#0077b5" },
  linkedinMessage: { icon: "🔗", label: "LinkedIn Message", color: "#0077b5" },
  linkedinVisit: { icon: "🔗", label: "LinkedIn Visit", color: "#0077b5" },
  call: { icon: "📞", label: "Appel", color: "#27ae60" },
  whatsapp: { icon: "💬", label: "WhatsApp", color: "#25d366" },
  task: { icon: "✅", label: "Tâche", color: "#f2994a" },
  api: { icon: "🔌", label: "API", color: "#6366f1" },
  delay: { icon: "⏳", label: "Délai", color: "#cbd5e1" },
  condition: { icon: "🔀", label: "Condition", color: "#8b5cf6" },
};

const StepCard = ({ step, selected, onClick, onDelete, readOnly }) => {
  const tc = TYPE_CONFIG[step.type] || TYPE_CONFIG.task;
  const config = get(step, "config", {});
  const label = config.label || tc.label;

  if (step.type === "delay") {
    return (
      <div onClick={onClick} style={{
        display: "inline-flex", alignItems: "center", gap: "6px",
        padding: "6px 16px", borderRadius: 12,
        background: "#f5f7fa", border: `1px solid ${selected ? "#8b5cf6" : "#e8ecf0"}`,
        color: "#6b7280", fontSize: 12, cursor: "pointer",
      }}>
        ⏳ {config.days || "?"} {config.type === "calendar_days" ? "jours calendaires" : "jours ouvrés"}
      </div>
    );
  }

  return (
    <div onClick={onClick} style={{
      width: 320, background: "#ffffff", borderRadius: 10,
      border: `1px solid ${selected ? tc.color : "#e8ecf0"}`,
      borderLeft: `4px solid ${tc.color}`,
      boxShadow: selected ? `0 0 0 2px ${tc.color}30` : "0 1px 3px rgba(0,0,0,0.04)",
      padding: "12px 14px", cursor: "pointer", transition: "all 0.15s",
    }}>
      <div className="d-flex justify--between" style={{ alignItems: "center" }}>
        <div className="d-flex" style={{ gap: "8px", alignItems: "center" }}>
          {!readOnly && <BiMenu size={14} style={{ color: "#d1d5db", cursor: "grab" }} />}
          <span style={{ fontSize: 16 }}>{tc.icon}</span>
          <strong style={{ fontSize: 13, color: "#1e293b" }}>{label}</strong>
        </div>
        {!readOnly && (
          <Button type="text" size="small" danger icon={<BiTrash size={14} />}
            onClick={(e) => { e.stopPropagation(); onDelete(); }}
          />
        )}
      </div>
      <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>
        {tc.label} {step.isAutomatic ? " · Auto" : " · Manuel"}
        {step.senderOverride && ` · ${step.senderOverride}`}
      </div>
      {step.type === "condition" && (
        <div style={{ fontSize: 11, color: "#8b5cf6", marginTop: 4 }}>
          {get(config, "conditionType", "").replace(/_/g, " ")}
          {config.timeframeDays && ` (${config.timeframeDays}j)`}
        </div>
      )}
      {step.type === "email" && config.subjectTemplate && (
        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4, fontStyle: "italic" }}>
          {config.subjectTemplate.substring(0, 50)}{config.subjectTemplate.length > 50 && "..."}
        </div>
      )}
    </div>
  );
};

export default StepCard;
